import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import { Chip } from '@mui/material';

type Props = {
  isHumanTakeover: boolean | undefined | null;
};

export const ControlChip: React.FC<Props> = ({ isHumanTakeover }) => {
  if (isHumanTakeover) {
    return <Chip label="You" />;
  }

  return <Chip icon={<AutoAwesomeOutlinedIcon />} label="Popp" />;
};
